import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "additional-information__content" }
const _hoisted_2 = {
  key: 0,
  class: "additional-information__chapter-title"
}
const _hoisted_3 = {
  key: 1,
  class: "additional-information__section additional-information__section--context"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "additional-information__section additional-information__section--counterarguments"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 3,
  class: "additional-information__section additional-information__section--actionables"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 4,
  class: "additional-information__section additional-information__section--learn-more"
}
const _hoisted_10 = {
  key: 5,
  class: "additional-information__section additional-information__section--related-summary"
}

import { computed } from 'vue'

import { Commentaries } from '@/models/interfaces'

import LearnMoreItem from '@/app/components/doc/reading/LearnMoreItem.vue'
import PaywallCTA from '@/components/public/PaywallCTA.vue'
import RelatedSummaryItem from '@/app/components/doc/reading/RelatedSummaryItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdditionalInformation',
  props: {
    commentaries: {},
    isPublicPage: { type: Boolean, default: false },
    title: {},
    order: {}
  },
  setup(__props: any) {

const props = __props

const textClasses = computed(() => {
  return addFade('additional-information__section-text')
})

const learnMoreItemClasses = computed(() => {
  return addFade('additional-information__learn-more-item')
})

const relatedSummaryItemClasses = computed(() => {
  return addFade('additional-information__related-summary-item')
})

const componentLocationClass = computed(() => {
  return props.isPublicPage
    ? 'additional-information--public'
    : 'additional-information--app'
})

/**
 * Add "--fade" modifier for all chapters except the first one.
 *
 * @param baseClass: base class of the additional information part.
 */
function addFade(baseClass: string): string[] {
  const classes = [baseClass]
  if (props.order !== 0 && props.isPublicPage) {
    classes.push(`${baseClass}--fade`)
  }
  return classes
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["additional-information", componentLocationClass.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.title)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.title), 1))
        : _createCommentVNode("", true),
      _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "additional-information__title" }, "Additional Materials", -1)),
      (__props.commentaries.context)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "additional-information__section-title" }, "Clarifications", -1)),
            _createElementVNode("div", {
              class: _normalizeClass(textClasses.value)
            }, [
              _createElementVNode("div", {
                innerHTML: __props.commentaries.context
              }, null, 8, _hoisted_4)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (__props.commentaries.counterarguments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "additional-information__section-title" }, "Counterarguments", -1)),
            _createElementVNode("div", {
              class: _normalizeClass(textClasses.value)
            }, [
              _createElementVNode("div", {
                innerHTML: __props.commentaries.counterarguments
              }, null, 8, _hoisted_6)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (__props.commentaries.actionables)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "additional-information__section-title" }, "Actionables", -1)),
            _createElementVNode("div", {
              class: _normalizeClass(textClasses.value)
            }, [
              _createElementVNode("div", {
                innerHTML: __props.commentaries.actionables
              }, null, 8, _hoisted_8)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (__props.commentaries.learn_more && __props.commentaries.learn_more.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "additional-information__section-title" }, "Learn more", -1)),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.commentaries.learn_more, (item) => {
                return (_openBlock(), _createBlock(LearnMoreItem, {
                  key: item.url,
                  class: _normalizeClass(learnMoreItemClasses.value),
                  item: item,
                  isPublicPage: __props.isPublicPage
                }, null, 8, ["class", "item", "isPublicPage"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (
          __props.commentaries.related_summaries &&
          __props.commentaries.related_summaries.length > 0
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "additional-information__section-title" }, " Related Shortform Content ", -1)),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.commentaries.related_summaries, (item) => {
                return (_openBlock(), _createBlock(RelatedSummaryItem, {
                  key: item.url,
                  class: _normalizeClass(relatedSummaryItemClasses.value),
                  item: item
                }, null, 8, ["class", "item"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.isPublicPage)
        ? (_openBlock(), _createBlock(PaywallCTA, {
            key: 6,
            class: "additional-information__cta"
          }, {
            title: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Get access to the context and additional materials", -1)
            ]))]),
            description: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("So you can understand the full picture and form your own opinion.", -1)
            ]))]),
            button: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Get access for free", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})